import { render, staticRenderFns } from "./HomeLugansk.vue?vue&type=template&id=f25cdc88&scoped=true"
import script from "./HomeLugansk.vue?vue&type=script&lang=ts"
export * from "./HomeLugansk.vue?vue&type=script&lang=ts"
import style0 from "./HomeLugansk.vue?vue&type=style&index=0&id=f25cdc88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25cdc88",
  null
  
)

export default component.exports